import {ClientSummary} from '../api/dtos/dtos';
import * as React from 'react';
import {Alert} from 'antd';
import locales from '../locales';
import * as paths from '../paths';
import {Link} from 'react-router-dom';
import {toCombinedAddress} from "../utils/form-utils";

interface ClientDetailsAlertProps {
  style?: React.CSSProperties;
  client: ClientSummary;
  closable?: boolean;
  onClose?: () => void;
}

class ClientDetailsAlert extends React.Component<ClientDetailsAlertProps, {}> {

  public render(): React.ReactNode {
    const {client} = this.props;
    const content = (
      <table>
        <tbody>
        {this.row(locales.name, <Link to={paths.viewClientPath(client.id)}>{client.name}</Link>)}
        {this.row(locales.address, toCombinedAddress(client))}
        {this.row(locales.taxNumber, client.taxNumber)}
        </tbody>
      </table>
    );

    return (
      <Alert
        style={{...this.props.style, marginTop: 4}}
        message={content}
        type="info"
        closable={this.props.closable}
        onClose={this.props.onClose}
      />
    );
  }

  private row = (title: string, value: React.ReactNode) => {
    if (!value) {
      return null;
    }
    return (
      <tr>
        <td style={{textAlign: 'right', paddingRight: 8}}><b>{title}</b></td>
        <td>{value}</td>
      </tr>
    );
  };

}

export default ClientDetailsAlert;


// WEBPACK FOOTER //
// ./src/client-details/ClientDetailsAlert.tsx